import i18next from 'i18next';
import React from 'react';

import styles from './styles.module.scss';

// Reassurance rows shown next to the ClaveÚnica form: what happens with the
// password, what data we consult and a password-manager tip.
const ROWS = [
  {
    id: 'password',
    titleKey: 'ClientUniqueKeyLogin:securityPasswordTitle',
    descKey: 'ClientUniqueKeyLogin:securityPasswordDesc',
    icon: (
      <svg
        className={styles.securityIcon}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect width="18" height="11" x="3" y="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    )
  },
  {
    id: 'data',
    titleKey: 'ClientUniqueKeyLogin:securityDataTitle',
    descKey: 'ClientUniqueKeyLogin:securityDataDesc',
    icon: (
      <svg
        className={styles.securityIcon}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
        <path d="M16 13H8" />
        <path d="M16 17H8" />
      </svg>
    )
  },
  {
    id: 'manager',
    titleKey: 'ClientUniqueKeyLogin:securityManagerTitle',
    descKey: 'ClientUniqueKeyLogin:securityManagerDesc',
    icon: (
      <svg
        className={styles.securityIcon}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round">
        <rect width="8" height="4" x="8" y="2" rx="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      </svg>
    )
  }
];

function SecurityCard() {
  return (
    <div className={styles.securityCard}>
      {ROWS.map(({ id, icon, titleKey, descKey }) => (
        <div key={id} className={styles.securityRow}>
          {icon}
          <div className={styles.securityText}>
            <span className={styles.securityRowTitle}>{i18next.t(titleKey)}</span>
            <span className={styles.securityRowDesc}>{i18next.t(descKey)}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SecurityCard;
